import { DEFAULT_GRID_COLUMN_COUNT } from "../Grid/index.js";
const getAlignValue = (value) => {
  switch (value) {
    case "right":
    case "bottom":
      return "flex-end";
    case "center":
      return "center";
    default:
      return "flex-start";
  }
};
const updateCSSVariables = (comp) => {
  const defaultCols = DEFAULT_GRID_COLUMN_COUNT;
  const cache = {
    desktop: comp.dsf_cols || defaultCols,
    // Inherit desktop style for tablet
    tablet: comp.dsf_cols_tablet || comp.dsf_cols || defaultCols,
    mobile: comp.dsf_cols_mobile || comp.dsf_cols_tablet || comp.dsf_cols || defaultCols
  };
  if (comp.dsf_cols_tablet) {
    cache.tablet = comp.dsf_cols_tablet;
  }
  if (comp.dsf_cols_mobile) {
    cache.mobile = comp.dsf_cols_mobile;
  }
  comp.style.setProperty("--dsf-grid-cell-cols-desktop", cache.desktop);
  comp.style.setProperty("--dsf-grid-cell-cols-tablet", cache.tablet);
  comp.style.setProperty("--dsf-grid-cell-cols-mobile", cache.mobile);
  comp.style.setProperty("--dsf-grid-cell-vertical", getAlignValue(comp.dsf_vertical));
  comp.style.setProperty("--dsf-grid-cell-horizontal", getAlignValue(comp.dsf_horizontal));
};
export {
  updateCSSVariables
};
